<template>
  <el-main v-loading="loading">
    <el-dialog width="90%" :visible.sync="edit_paper_show"
               :title="`${current_row.title}【${current_row.subject}】-试卷管理`">
      <PaperEditer :exam_id="current_row.id"></PaperEditer>
    </el-dialog>
    <el-dialog width="90%" :visible.sync="select_student_show"
               :title="`${current_row.title}【${current_row.subject}】-名册管理`">
      <StudentSelect :exam_id="current_row.id"></StudentSelect>
    </el-dialog>
    <el-dialog width="90%" title="编辑考试" :visible.sync="exam_form_edit_show"
               :close-on-click-modal="false">
      <el-alert
          title="当前考试已经发布，只能编辑基本信息，不能编辑题块"
          type="error"
          v-if="exam_form_edit.publish_flag===true"
      >
      </el-alert>
      <el-alert
          title="【起止时间】指考生可以提交和修改答案的时间范围，远程交卷时建议将结束时间适当延长。"
          type="info"
      >
      </el-alert>
      <el-form inline size="mini" style="text-align: left">
        <el-form-item label="考试名称">
          <el-input v-model="exam_form_edit.title" placeholder="考试名称"></el-input>
        </el-form-item>
        <el-form-item label="考试科目">
          <el-select v-model="exam_form_edit.subject" placeholder="请选择" style="width: 80px">
            <el-option
                v-for="subject in subject_choices"
                :label="subject"
                :key="subject"
                :value="subject">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="限定名册">-->
        <!--          <el-switch v-model="exam_form_edit.group_student_flag" disabled=""></el-switch>-->
        <!--        </el-form-item>-->
        <el-form-item label="考试说明">
          <el-input v-model="exam_form_edit.describe" placeholder="考试说明"></el-input>
        </el-form-item>
        
        <!--                <el-form-item label="加入模式">-->
        <!--                    <el-select v-model="exam_form_edit.join_mode" placeholder="请选择" style="width: 100px">-->
        <!--                        <el-option-->
        <!--                                label="手机绑定"-->
        <!--                                value="p">-->
        <!--                        </el-option>-->
        <!--                        <el-option-->
        <!--                                label="验证码"-->
        <!--                                value="c" disabled>-->
        <!--                        </el-option>-->
        <!--                        <el-option-->
        <!--                                label="手机绑定/验证码"-->
        <!--                                value="a" disabled>-->
        <!--                        </el-option>-->
        <!--                    </el-select>-->
        <!--                </el-form-item>-->
        <el-form-item label="起止时间">
          <el-date-picker
              v-model="exam_form_edit.time_range"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <ExamForm
          :answer_table="answer_table_edit" :lock_flag="exam_form_edit.publish_flag"></ExamForm>
      <span slot="footer">
    <el-button type="primary" @click="edit_exam">确定</el-button>
  </span>
    </el-dialog>
    <el-dialog width="90%" title="创建考试" :visible.sync="exam_form_show"
               :close-on-click-modal="false">
      <el-alert
          title="【起止时间】指考生可以提交和修改答案的时间范围，远程交卷时建议将结束时间适当延长。"
          type="info"
      >
      </el-alert>
      <el-form inline size="mini" style="text-align: left">
        <el-form-item label="考试名称">
          <el-input v-model="exam_form.title" placeholder="考试名称"></el-input>
        </el-form-item>
        <el-form-item label="考试科目">
          <el-select v-model="exam_form.subject" placeholder="请选择" style="width: 80px">
            <el-option
                v-for="subject in subject_choices"
                :label="subject"
                :key="subject"
                :value="subject">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="限定名册">-->
        <!--          <el-switch v-model="exam_form.group_student_flag"></el-switch>-->
        <!--        </el-form-item>-->
        <el-form-item label="考试说明">
          <el-input v-model="exam_form.describe" placeholder="考试说明"></el-input>
        </el-form-item>
        <!--                <el-form-item label="加入模式">-->
        <!--                    <el-select v-model="exam_form.join_mode" placeholder="请选择" style="width: 100px">-->
        <!--                        <el-option-->
        <!--                                label="手机绑定"-->
        <!--                                value="p">-->
        <!--                        </el-option>-->
        <!--                        <el-option-->
        <!--                                label="验证码"-->
        <!--                                value="c" disabled>-->
        <!--                        </el-option>-->
        <!--                        <el-option-->
        <!--                                label="手机绑定/验证码"-->
        <!--                                value="a" disabled>-->
        <!--                        </el-option>-->
        <!--                    </el-select>-->
        <!--                </el-form-item>-->
        <el-form-item label="起止时间">
          <el-date-picker
              v-model="exam_form.time_range"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <ExamForm
          :answer_table="answer_table" :lock_flag="false"></ExamForm>
      <span slot="footer">
    <el-button type="primary" @click="create_exam">确定</el-button>
  </span>
    </el-dialog>
    <el-dialog :title="`【${exam_form_edit.title}】标答配置`" :visible.sync="choice_form_show"
               :close-on-click-modal="false" width="90%">
      <ChoiceForm
          :choice_table="choice_table" :code="exam_form_edit.id"></ChoiceForm>
    </el-dialog>
    <el-dialog :title="`【${exam_form_edit.title}】阅卷配置`" :visible.sync="review_form_show" width="90%"
               :close-on-click-modal="false">
      <ReviewForm
          :review_table="review_table" :code="exam_form_edit.id"></ReviewForm>
      <span slot="footer">
        <el-button type="primary" @click="review_form_show=false">关闭
            </el-button>
  </span>
    </el-dialog>
    <el-form inline size="mini" style="text-align: left" v-if="parent_group!==true">
      <el-form-item>
        <el-button icon="el-icon-plus" type="warning" size="medium" @click="create_exam_init">创建</el-button>
      </el-form-item>
    </el-form>
    <el-form inline size="mini">
      <el-form-item>
        名称：
        <el-input v-model="search_form.title" placeholder="名称" style="width: 120px;"></el-input>
      </el-form-item>
      <el-form-item>
        科目：
        <el-select v-model="search_form.subject" placeholder="请选择" style="width: 100px" clearable="">
          <el-option
              v-for="subject in subject_choices"
              :label="subject"
              :key="subject"
              :value="subject">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="起止时间">
        <el-date-picker
            v-model="search_form.time_range"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm"
            range-separator="至"
            start-placeholder="开始"
            end-placeholder="结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        已归档：
        <el-select v-model="search_form.freeze_flag" placeholder="请选择" style="width: 100px" clearable="">
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query_exam(true)">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-pagination
        background
        layout="prev, pager, next, sizes, total, jumper"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="page_size"
        :total="table_totle"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>
    <el-table
        :data="table_data"
        border
        fit
        size="mini"
        style="width: 100%">
            <el-table-column
          prop="id"
          label="ID"
          width="80px">
      </el-table-column>
      <el-table-column
          prop="group__name"
          label="分组" v-if="parent_group"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="create_user__name"
          label="创建人" v-if="parent_group"
          width="80px">
      </el-table-column>
      <el-table-column
          prop="title"
          label="名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="subject"
          label="科目"
          width="50px">
      </el-table-column>
      <el-table-column
          prop="start_time"
          label="开始时间"
          width="140px">
      </el-table-column>
      <el-table-column
          prop="end_time"
          label="结束时间"
          width="140px">
      </el-table-column>
      <el-table-column
          label="发布状态" width="80px">
        <template slot-scope="scope">
          <template v-if="scope.row.publish_flag">
            <el-tag effect="dark" type="success" size="mini">已发布</el-tag>
          </template>
          <template v-else>
            <el-tag effect="dark" type="warning" size="mini">未发布</el-tag>
          </template>&nbsp;
        </template>
      </el-table-column>
      <el-table-column
          label="阅卷状态" width="80px">
        <template slot-scope="scope">
          <template v-if="scope.row.review_flag">
            <el-tag effect="dark" type="success" size="mini">已启动</el-tag>
          </template>
          <template v-else>
            <el-tag effect="dark" type="warning" size="mini">未启动</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          label="推送状态" width="80px">
        <template slot-scope="scope">
          <template v-if="scope.row.score_flag">
            <el-tag effect="dark" type="success" size="mini">已推送</el-tag>
          </template>
          <template v-else>
            <el-tag effect="dark" type="warning" size="mini">未推送</el-tag>
          </template>
        </template>
      </el-table-column>
      
      <el-table-column
          label="配置/发布" width="210px" v-if="!parent_group">
        <template slot-scope="scope">
          <el-button-group>
            <el-button size="mini" @click="edit_exam_init(scope.row)" type="primary"
            >编辑
            </el-button>
            <el-button size="mini" @click="edit_paper_init(scope.row)" type="info"
            >试卷
            </el-button>
            <template v-if="!scope.row.freeze_flag">
              <template v-if="scope.row.publish_flag">
                <el-button size="mini" type="danger" @click="publish_exam(scope.row,false)"
                >撤回
                </el-button>
              </template>
              <template v-else>
                <el-button size="mini" type="success" @click="publish_exam(scope.row,true)"
                >发布
                </el-button>
              </template>
            </template>
          </el-button-group>
        </template>
      </el-table-column>
      <el-table-column
          label="考试名册" :width="parent_group?'80px':'140px'">
        <template slot-scope="scope">
          <el-button-group>
            <el-button size="mini" type="primary" @click="select_students(scope.row)"
                       v-if="!parent_group">选择
            </el-button>
            <el-button size="mini" type="success" @click="download_student(scope.row)">导出</el-button>
          </el-button-group>
        </template>
      </el-table-column>
      <el-table-column
          label="阅卷/监控" :width="parent_group?'80px':'200px'">
        <template slot-scope="scope">
          <el-button-group>
            <el-button size="mini" type="primary" @click="review_init(scope.row)"
                       :disabled="scope.row.publish_flag!==true" v-if="!parent_group"
            >配置
            </el-button>
            <template v-if="!parent_group&&!scope.row.freeze_flag">
              <template v-if="scope.row.review_flag">
                <el-button size="mini" type="danger" @click="review_exam(scope.row)"
                >停止
                </el-button>
              </template>
              <template v-else>
                <el-button size="mini" type="success" @click="review_exam(scope.row)"
                           :disabled="scope.row.publish_flag!==true"
                >启动
                </el-button>
              </template>
            </template>
            <el-button size="mini" type="info" @click="get_statistics(scope.row)"
            >统计
            </el-button>
          </el-button-group>
        </template>
      </el-table-column>
      <el-table-column
          label="成绩管理" :width="parent_group?'140px':'200px'">
        <template slot-scope="scope">
          <el-button-group>
            <el-button size="mini" type="primary" @click="choice_init(scope.row)"
                       :disabled="scope.row.publish_flag!==true" v-if="!parent_group"
            >标答
            </el-button>
            <el-button size="mini" type="info" @click="get_scores(scope.row)"
                       :disabled="scope.row.publish_flag!==true"
            >导出
            </el-button>
            <template v-if="!scope.row.freeze_flag">
              <template v-if="scope.row.score_flag">
                <el-button size="mini" type="danger" @click="publish_scores(scope.row,false)"
                           :disabled="scope.row.publish_flag!==true"
                >撤回
                </el-button>
              </template>
              <template v-else>
                <el-button size="mini" type="success" @click="publish_scores(scope.row,true)"
                           :disabled="scope.row.publish_flag!==true"
                >推送
                </el-button>
              </template>
            </template>
          </el-button-group>
        </template>
      </el-table-column>
      <el-table-column
          label="归档" width="80px" v-if="!parent_group">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="freeze_exam(scope.row)" v-if="!scope.row.freeze_flag">归档
          </el-button>
          <el-tag v-else effect="dark" type="info" size="mini">已归档</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <input type="file" ref="student_file" style="display:none" @change="on_student_change"/>
  </el-main>
</template>

<script>
  import XLSX from "xlsx";
  import Base from "./Base";
  import global_ from "../global";

  const admin_api = global_.admin_api;
  import ExamForm from "../components/ExamForm"
  import ReviewForm from "../components/ReviewForm"
  import StudentSelect from "../components/StudentSelect"
  import PaperEditer from "../components/PaperEditer"
  import ChoiceForm from "../components/ChoiceForm"
  import FileSaver from "file-saver";

  export default {
    name: "ExamManage",
    components: {ExamForm, ReviewForm, ChoiceForm, StudentSelect, PaperEditer},
    created() {
      this.query_exam()
    },
    extends: Base,
    mounted() {
      this.$store.commit('set_current_url', "/exam_manage")
    },
    computed: {
      parent_group() {
        return this.$store.state.parent_group;
      },
    },
    data() {
      return {
        subject_choices: ['语文', '数学', '英语', '物理', '化学', '生物', '历史', '地理', '政治', '日语'],
        loading: false,
        select_student_show: false,
        page_num: 1,
        edit_paper_show: false,
        page_size: 10,
        table_totle: 0,
        table_data: [],
        exam_form_show: false,
        review_form_show: false,
        exam_form_edit_show: false,
        choice_table: [],
        choice_form_show: false,
        exam_form: {
          title: "",
          time_range: [],
          join_mode: 'p',
          describe: "",
          subject: "",
          group_student_flag: true
        },
        search_form: {
          title: "",
          subject: "",
          freeze_flag: "N",
          time_range: [],
        },
        current_row: {},
        exam_form_edit: {
          id: "",
          title: "",
          time_range: [],
          default_time: [],
          publish_flag: false,
          join_mode: 'p',
          describe: "",
          subject: "",
          group_student_flag: true
        },
        answer_table: [],
        review_table: [],
        answer_table_edit: [],
      }
    },
    methods: {
      get_scores(row) {
        this.loading = true
        let request_data = {
          service_name: 'get_scores', id: row.id
        }
        fetch(admin_api, {
          method: 'POST', // or 'PUT'
          body: JSON.stringify(request_data), // data can be `string` or {object}!
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => {
          this.loading = false
          if (res.headers.get("content-type") === "application/json") {
            res.json().then(
              json => {
                this.$alert(json.result_info, '提示')
              }
            )
          } else {
            res.blob().then(blob => FileSaver.saveAs(blob, "成绩.xlsx"))
          }
        })
      },
      get_statistics(row) {
        let request_data = {
          service_name: 'get_statistics', id: row.id
        }
        this.axios.post(admin_api, request_data).then(response => {
          let response_data = response.data
          let result_info = response_data['result_info']
          const h = this.$createElement;
          this.$msgbox({
            title: '统计数据',
            message: h('p', null, [
              h('strong', null, '考生'),
              h('br', null, null),
              h('span', null, '总人数:'),
              h('strong', {style: 'color: teal'}, result_info['student_count']),
              h('br', null, null),
              h('span', null, '已参加人数:'),
              h('strong', {style: 'color: teal'}, result_info['student_start_count']),
              h('br', null, null),
              h('span', null, '提前交卷数:'),
              h('strong', {style: 'color: teal'}, result_info['end_student_count']),
              h('br', null, null),
              h('strong', null, '客观题'),
              h('br', null, null),
              h('span', null, '总数:'),
              h('strong', {style: 'color: teal'}, result_info['choice_question_count']),
              h('br', null, null),
              h('span', null, '完成数:'),
              h('strong', {style: 'color: teal'}, result_info['end_choice_question_count']),
              h('br', null, null),
              h('strong', null, '主观题'),
              h('br', null, null),
              h('span', null, '总块数:'),
              h('strong', {style: 'color: teal'}, result_info['subjective_area_count']),
              h('br', null, null),
              h('span', null, '完成数:'),
              h('strong', {style: 'color: teal'}, result_info['end_subjective_area_count']),
              h('br', null, null),
              h('strong', null, '阅卷'),
              h('br', null, null),
              h('span', null, '完成数:'),
              h('strong', {style: 'color: teal'}, result_info['end_score_area_count']),
              h('br', null, null),
              h('strong', null, '多评'),
              h('br', null, null),
              h('span', null, '待课组长处理数:'),
              h('strong', {style: 'color: teal'}, result_info['need_super_count'])
            ]),
            confirmButtonText: '确定',
          })
        })
      },
      review_exam(row) {
        let tip = row.review_flag ? '确定要停止阅卷？' : '确定要启动阅卷？'
        this.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let request_data = {
              service_name: 'review_exam',
              flag: !row.review_flag,
              id: row.id,
            }
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              let result_code = response_data['result_code']
              let result_info = response_data['result_info']
              if (result_code === '00') {
                row.review_flag = !row.review_flag
              } else {
                this.$alert(result_info, '提示', {
                  confirmButtonText: '确定',
                });
              }
            })
          }
        )
      },
      select_students(row) {
        this.current_row = row
        this.select_student_show = true
      },
      set_students(row) {
        this.current_row = row
        this.$refs.student_file.value = ""
        this.$refs.student_file.click()
      },
      download_student(row) {
        this.loading = true
        let request_data = {
          service_name: 'down_exam_student', id: row.id
        }
        fetch(admin_api, {
          method: 'POST', // or 'PUT'
          body: JSON.stringify(request_data), // data can be `string` or {object}!
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => {
          this.loading = false
          if (res.ok) {
            res.blob().then(blob => FileSaver.saveAs(blob, "名册.xlsx"))
          } else {
            let d = [['学号', '姓名', '手机号']]
            let ws = XLSX.utils.aoa_to_sheet(d);
            let wb = XLSX.utils.book_new();
            let fn = "名册.xlsx";
            XLSX.utils.book_append_sheet(wb, ws);
            let wbout = XLSX.write(wb, {
              bookType: "xlsx",
              bookSST: true,
              type: "array"
            });
            FileSaver.saveAs(
              new Blob([wbout], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
              }),
              fn
            );
          }
        })
      },
      on_student_change(e) {
        let file = e.target.files[0];
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(file);
        fileReader.onload = e => {
          this.loading = true
          let data = e.target.result;
          let wb = XLSX.read(data, {
            type: "binary"
          });
          for (let index in wb.Sheets) {
            let sheet = wb.Sheets[index];
            let students = XLSX.utils.sheet_to_json(sheet, {
              range: 1,
              header: ['id_num', 'name', 'phone'],
              raw: false
            });
            let id_nums = []
            for (let _ of students) {
              if (!/^1[3-9][0-9][\d]{8}$/.test(_.phone)) {
                this.$message({message: "数据中包含不合法的手机号", duration: 1000, type: 'warning'})
                return
              }
              if (id_nums.indexOf(_.id_num) !== -1) {
                this.$message({message: `学号【${_.id_num}】重复`, duration: 1000, type: 'warning'})
                return
              }
              id_nums.push(_.id_num)
            }

            let request_data = {service_name: 'set_students', students: students, id: this.current_row.id}
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              this.loading = false
              this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
            })
            break
          }
        }
        fileReader.onloadend = () => {
          this.loading = false
        }
        fileReader.onloadstart = () => {
          this.loading = true
        }
      },
      choice_init(row) {
        this.exam_form_edit = row
        let request_data = {
          service_name: 'query_choice_table',
          id: this.exam_form_edit.id,
        }
        this.axios.post(admin_api, request_data).then(
          response => {
            let response_data = response.data
            let result_code = response_data['result_code']
            let result_info = response_data['result_info']
            if (result_code === '00') {
              this.choice_table = result_info
              this.choice_form_show = true
            } else {
              this.$alert(result_info, '提示', {
                confirmButtonText: '确定',
              });
            }
          }
        )
      },
      edit_paper_init(row) {
        this.current_row = row
        this.edit_paper_show = true
      },
      review_init(row) {
        this.exam_form_edit = row
        let request_data = {
          service_name: 'query_review_table',
          id: this.exam_form_edit.id,
        }
        this.axios.post(admin_api, request_data).then(
          response => {
            let response_data = response.data
            let result_code = response_data['result_code']
            let result_info = response_data['result_info']
            if (result_code === '00') {
              this.review_table = result_info
              this.review_form_show = true
            } else {
              this.$alert(result_info, '提示', {
                confirmButtonText: '确定',
              });
            }
          }
        )
      },
      freeze_exam(row) {
        this.$confirm('确定要将本次考试归档吗？（归档后将不可更改任何数据）', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let request_data = {
              service_name: 'freeze_exam',
              id: row.id,
            }
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              let result_code = response_data['result_code']
              let result_info = response_data['result_info']
              if (result_code === '00') {
                this.query_exam()
              } else {
                this.$alert(result_info, '提示', {
                  confirmButtonText: '确定',
                });
              }
            })
          }
        )
      },
      publish_scores(row, flag) {
        let tip = flag ? '确定要推送成绩？' : '确定要撤回成绩？'
        this.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(
          () => {
            let request_data = {
              service_name: 'publish_scores',
              id: row.id,
              flag: flag
            }
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              let result_info = response_data['result_info']
              let result_code = response_data['result_code']
              if (result_code === '00') {
                row.score_flag = flag
              }
              this.$alert(result_info, '提示', {
                confirmButtonText: '确定',
              });
            })
          }
        )
      },
      publish_exam(row, flag) {
        let tip = flag ? '确定要发布考试吗？（发布考试后题块将不可更改）' : '确定要撤回考试吗？（除考试名册外，其它配置都将清除）'
        this.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(
          () => {
            let request_data = {
              service_name: 'publish_exam',
              page_num: this.page_num,
              page_size: this.page_size,
              flag: flag,
              id: row.id,
            }
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              let result_code = response_data['result_code']
              let result_info = response_data['result_info']
              if (result_code === '00') {
                row.publish_flag = flag
              } else {
                this.$alert(result_info, '提示', {
                  confirmButtonText: '确定',
                });
              }
            })
          }
        )


      },
      edit_exam_init(row) {
        this.exam_form_edit = {
          id: row.id,
          title: row.title,
          time_range: [row.start_time, row.end_time],
          join_mode: row.join_mode,
          describe: row.describe,
          subject: row.subject,
          publish_flag: row.publish_flag,
          group_student_flag: true
        }
        let request_data = {
          service_name: 'query_exam_config',
          id: this.exam_form_edit.id,
        }
        this.axios.post(admin_api, request_data).then(
          response => {
            let response_data = response.data
            let result_code = response_data['result_code']
            let result_info = response_data['result_info']
            if (result_code === '00') {
              this.answer_table_edit = result_info
              this.exam_form_edit_show = true
            } else {
              this.$alert(result_info, '提示', {
                confirmButtonText: '确定',
              });
            }
          }
        )
      },
      edit_exam() {
        if (this.exam_form_edit.title.length < 2) {
          this.$alert('考试名称不能为空', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        if (this.exam_form_edit.subject.length < 1) {
          this.$alert('考试科目不能为空', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        if (this.exam_form_edit.time_range.length !== 2) {
          this.$alert('请设置起止时间', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        if (this.answer_table_edit.length === 0) {
          this.$alert('请添加题块', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        for (let question_group of this.answer_table_edit) {
          if (question_group.questions.length === 0) {
            this.$alert(`题块【${question_group.label}】没有添加小题，请检查`, '提示', {
              confirmButtonText: '确定',
            });
            return
          }
        }
        this.$confirm('修改考试配置，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let request_data = {
            service_name: 'add_exam',
            page_num: this.page_num,
            page_size: this.page_size,
            exam_form: this.exam_form_edit,
            answer_table: this.answer_table_edit
          }
          this.axios.post(admin_api, request_data).then(response => {
            let response_data = response.data
            let result_code = response_data['result_code']
            let result_info = response_data['result_info']
            if (result_code === '00') {
              this.query_exam()
              this.exam_form_edit_show = false
            } else {
              this.$alert(result_info, '提示', {
                confirmButtonText: '确定',
              });
            }
          })
        }).catch(() => {
          this.exam_form_edit_show = false
        });
      },
      create_exam() {
        if (this.exam_form.title.length < 2) {
          this.$alert('考试名称不能为空', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        if (this.exam_form.subject.length < 1) {
          this.$alert('考试科目不能为空', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        if (this.exam_form.time_range.length !== 2) {
          this.$alert('请设置起止时间', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        if (this.answer_table.length === 0) {
          this.$alert('请添加题块', '提示', {
            confirmButtonText: '确定',
          });
          return
        }
        for (let question_group of this.answer_table) {
          if (question_group.questions.length === 0) {
            this.$alert(`题块【${question_group.label}】没有添加小题，请检查`, '提示', {
              confirmButtonText: '确定',
            });
            return
          }
        }
        let request_data = {
          service_name: 'add_exam',
          page_num: this.page_num,
          page_size: this.page_size,
          exam_form: this.exam_form,
          answer_table: this.answer_table
        }
        this.axios.post(admin_api, request_data).then(response => {
          let response_data = response.data
          let result_code = response_data['result_code']
          let result_info = response_data['result_info']
          if (result_code === '00') {
            this.query_exam()
            this.exam_form_show = false
          } else {
            this.$alert(result_info, '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      },
      create_exam_init() {
        this.exam_form_show = true
      },
      query_exam(is_new = false) {
        if (is_new) {
          this.page_num = 1
        }
        let request_data = {
          service_name: 'query_exam',
          search_form: this.search_form,
          page_num: this.page_num,
          page_size: this.page_size,
        }
        this.axios.post(admin_api, request_data).then(response => {
          let response_data = response.data
          let result_code = response_data['result_code']
          let result_info = response_data['result_info']
          if (result_code === '00') {
            this.table_data = result_info['table_data']
            this.table_totle = result_info['table_totle']
          } else {
            this.$alert(result_info, '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      },
      handleCurrentChange(v) {
        this.page_num = v
        this.query_exam()
      },
      handleSizeChange(v) {
        this.page_size = v
        this.query_exam()
      },
    }
  }
</script>

